import { BaseMediaUrl, Discussion } from '../../constants/apis';
import type {
  DiscussionInfoResponseType,
  FeedbackTopicType,
  ReviewInfoResponseType,
  StickerPack,
} from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

export const getDiscussionInfo = async (topicType: FeedbackTopicType, topicId: string, token?: string) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  return await ApiManager.get<DiscussionInfoResponseType>(
    `${Discussion}/discussion-info/${topicType}/${topicId}`,
    {
      headers,
    },
  );
};

export const getReviewInfo = async (topicType: FeedbackTopicType, topicId: string, token?: string) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  return await ApiManager.get<ReviewInfoResponseType>(`${Discussion}/review-info/${topicType}/${topicId}`, {
    headers,
  });
};

export const getMultipleReviewInfos = async (
  topicType: FeedbackTopicType,
  topicIds: string[],
  token?: string,
) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const multiReviewInfoUrl = new URL(`${Discussion}/review-info/multi/${topicType}`);
  const params = new URLSearchParams();
  if (topicIds && topicIds.length > 0) {
    topicIds.forEach((id) => {
      params.append(`topicIds`, id);
    });
  }

  multiReviewInfoUrl.search = params.toString();

  return await ApiManager.get<ReviewInfoResponseType[]>(multiReviewInfoUrl.toString(), {
    headers,
  });
};

export const getStickerPacks = () => {
  return ApiManager.get<StickerPack[]>(`${BaseMediaUrl}/api/sticker-packs`);
};
